import { HeaderRoute } from "./models/HeaderRoute";

export const headerRoutes: HeaderRoute[] = [
    {
        route: "/account",
        data: { type: "account" },
        icon: "user",
        text: "Compte"
    },
    {
        route: "/",
        data: { type: "logout" },
        icon: "logout",
        text: "Déconnexion"
    }
];